import { render, staticRenderFns } from "./LazyBackground.vue?vue&type=template&id=8c80cbfe&"
import script from "./LazyBackground.vue?vue&type=script&lang=js&"
export * from "./LazyBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports